<template>
    <div  class="authenticate-panel grid xs-grid-cols-1 gap-3">
        <div class="text-center" v-if="formInfo.showLogo">
            <img class="signin-membership-logo" :src="glb.cdnUrl + 'vimages/movoto-lower-logo.svg'" alt="Movoto">
        </div>
        <div class="text-center grid xs-grid-cols-1 gap-1">
            <h3 v-if="formInfo.title" class="f3 text-bold" data-role="title">{{formInfo.title}}</h3>
            <div v-if="formInfo.desc" class="f5">{{formInfo.desc}}</div>
        </div>
        <div v-if="formInfo.benefits.length" class="inline large corner bg-main-l1 p-y-3 p-x-3 grid xs-grid-cols-1 gap-2">
            <div class="f5 text-bold text-center">{{formInfo.panelTitle}}</div>
            <ul class="grid xs-grid-cols-1 gap-2">
                <li v-for="item in formInfo.benefits" :key="item.text" class="flex left middle gap-2">
                    <i class="tag-icon bg-white" :class="item.icon" aria-hidden="true"></i>
                    <span class="f5">{{item.text}}</span>
                </li>
            </ul>
        </div>
        <form class="form form-default grid xs-grid-cols-1 gap-3" :class="glb.authFormState"  v-submit="submitSignup">
            <mvtTextbox>
                <div class="input">
                    <label>Email</label>
                    <input type="email" v-model="email"  v-validate="'required|email'" />
                </div>
            </mvtTextbox>
            <div v-if="glb.authErrorMessage" class="text-error">{{glb.authErrorMessage}}</div>
            <div class="f5" v-if="formInfo.showDisclaimer">
                {{molang('dpp.mvtEmail.disclaimer')}}
            </div>
            <button class="btn primary regular" type="submit" >{{formInfo.buttonText}}</button>
            <div class="login-alternate">
                <hr>or<hr>
            </div>
            <mvtSocial :requestName="options.requestName" :trigger="options.trigger"/>
            <div class="f8 text-a lh-normal" v-html="formInfo.termsHtml || molang('dpp.mvtEmail.movotoTerms1')">
            </div>
        </form>
    </div>
</template>
<script src="./mvt-checkemail.js"></script>
